import { defineComponent as _defineComponent } from 'vue'
import { watch, ref, onMounted, provide } from "vue"
import PersonalInfoFormContainer from "../../Invitation/PersonalInfoForm/PersonalInfoFormContainer.vue"
import { Step } from "../../Invitation/constants"
import InvitationLayout from "../../Invitation/shared/InvitationLayout.vue"
import { SubscriptionForm as SubscriptionFormType } from "../../Invitation/shared/types"

import { useMutation } from "@/hooks/useMutation"
import CheckStep from "../../Invitation/shared/CheckStep.vue"
import { useNotification } from "@/hooks/useNotification"
import CompanyInfoForm from "../../Invitation/CompanyInfoForm/CompanyInfoForm.vue"
import SubscriptionForm from "../../Invitation/SubscriptionForm/SubscriptionForm.vue"
import { THEMES } from "@/constants"
import {
  CreateClientWithUserMutation,
  CreateClientWithUserMutationMutation,
  CreateClientWithUserMutationMutationVariables,
  SubscriptionInput,
  FindProductPlansQuery,
  UserInput,
  FindProductPlansQueryQuery,
  ProductPlanFragmentFragment,
  CardInput,
  CohortPeriodTypeEnum,
  ClientInput,
} from "@/gql"
import { useLazyQuery } from "@vue/apollo-composable"


export default /*#__PURE__*/_defineComponent({
  __name: 'AheadClientSignupFlow',
  setup(__props) {

const step = ref(Step.CompanyInfo)
const stages = [Step.CompanyInfo, Step.PersonalInfo, Step.Subscription]
const completedSteps = ref<string[]>([])

watch(step, () => (completedSteps.value = [...completedSteps.value, step.value]), {
  immediate: true,
})

const gotoNext = () => {
  const index = stages.findIndex((s) => s === step.value)
  if (index < stages.length - 1) {
    step.value = stages[index + 1]
  }
}

const gotoPrev = () => {
  const index = stages.findIndex((s) => s === step.value)
  if (index > 0) {
    step.value = stages[index - 1]
  }
}

const isSubmitting = ref(false)
const selectedPlan = ref<ProductPlanFragmentFragment | null>(null)

const { addSuccess } = useNotification()

const form = ref<SubscriptionFormType>({
  newUserInput: {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phone: {
      countryCode: "",
      number: "",
    },
  },
  newClientInput: {
    name: "",
    website: "",
    countryId: "",
    address: "",
    description: "",
    industry: "",
    companySizeRange: null,
  },
  newSubscriptionInput: {
    productPlanId: "",
    seatsUsageCount: 1,
    promoCode: "",
    cohortPeriod: CohortPeriodTypeEnum.Cohort_1,
  },
  newCardInput: {
    cardType: "",
    lastFour: "",
    name: "",
    paymentToken: "",
    stripeCardId: "",
  },
})

const theme = {
  primaryColor: THEMES.AHEAD_PRIMARY,
  textColor: THEMES.WHITE_TEXT_COLOR,
  iconColor: THEMES.AHEAD_PRIMARY_COLOR,
}

const userInputFields = ["email", "phone", "clientAdminPosition", "password"]

const updateUserInput = (value: UserInput) => {
  form.value = {
    ...form.value,
    newUserInput: {
      ...form.value.newUserInput,
      ...value,
    },
  }
}

const updateSubscriptionInput = (value: SubscriptionInput) => {
  form.value = {
    ...form.value,
    newSubscriptionInput: {
      ...form.value.newSubscriptionInput,
      ...value,
    },
  }
}

const updateCardInput = (value: CardInput) => {
  form.value = {
    ...form.value,
    newCardInput: {
      ...form.value.newCardInput,
      ...value,
    },
  }
}
const { mutate } = useMutation()

const onSubmit = async () => {
  isSubmitting.value = true

  if (!form.value.newCardInput?.stripeCardId) {
    form.value.newCardInput = undefined
  }

  // Mutate
  const result = await mutate<
    CreateClientWithUserMutationMutation,
    CreateClientWithUserMutationMutationVariables
  >({
    mutation: CreateClientWithUserMutation,
    variables: {
      ...form.value,
    },
    handlePayloadErrors: true,
  })

  // Done
  if (result?.data?.createClientWithUser?.clientPayload?.subscriptionId) {
    addSuccess("Sign up successful!")
    const payInvoiceUrl = result?.data?.createClientWithUser.clientPayload.payInvoiceUrl

    const subscriptionId = result?.data?.createClientWithUser.clientPayload.subscriptionId

    if (payInvoiceUrl) {
      window.location.href = payInvoiceUrl
    }

    if (subscriptionId) {
      localStorage.setItem("POST_SIGN_UP_SUBSCRIPTION_ID", subscriptionId)
    }
  }

  isSubmitting.value = false
}

const searchParams = new URLSearchParams(new URL(window.location.href).search)

const {
  load: fetchProductPlans,
  loading,
  result: plans,
  onResult: onProductPlansQueryResult,
} = useLazyQuery<FindProductPlansQueryQuery>(FindProductPlansQuery, {
  productSlug: "ahead_business",
})

const updateClientInput = (value: ClientInput) => {
  form.value = {
    ...form.value,
    newClientInput: {
      ...form.value.newClientInput,
      ...value,
    },
  }
}

onProductPlansQueryResult((result) => {
  if (result?.data?.findProductPlans && searchParams.get("product_plan")) {
    const selectedProductPlan = result.data.findProductPlans.find(
      (item) => item.slug === searchParams.get("product_plan")
    )
    if (selectedProductPlan) {
      form.value.newSubscriptionInput.productPlanId = selectedProductPlan.prn
      selectedPlan.value = selectedProductPlan
    }
  }
})

provide("onboardingForm", form)

onMounted(() => {
  if (!searchParams.get("promo_code")) {
    fetchProductPlans()
  }
})

return { __sfc: true,step, stages, completedSteps, gotoNext, gotoPrev, isSubmitting, selectedPlan, addSuccess, form, theme, userInputFields, updateUserInput, updateSubscriptionInput, updateCardInput, mutate, onSubmit, searchParams, fetchProductPlans, loading, plans, onProductPlansQueryResult, updateClientInput, PersonalInfoFormContainer, Step, InvitationLayout, CheckStep, CompanyInfoForm, SubscriptionForm }
}

})